import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {useAuth} from '@/contexts/AuthContext.tsx';
import accountService from "@/services/accounts/AccountService.ts";
import bankAccountService from "@bankAccountService";

export function useFetchAccounts() {
  const { user } = useAuth();
  return useQuery({
    queryKey: ['accounts', user?.id],
    queryFn: async () => {
      // TODO: fetch all accounts, i.e. bank accounts, mobile_money_accounts, card_accounts, trading_accounts, etc
      //  This will be handled at the service layer to ensure that the data is properly grouped for the UI to render
      //  correctly.
      // const bankAccounts = await bankAccountService.fetchAllBankAccountsByUser(user!.id);
      // const accounts =  await accountService.fetchAllAccounts(user!.id);
      // return [...accounts, ...bankAccounts]
      return await accountService.fetchAllAccounts(user!.id);
    },
    enabled: !!user,
  });
}

export function useCreateAccount() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (account: Omit<AccountCreateRequest, 'userId'>) => {
      return await accountService.createAccount({ ...account, userId: user!.id });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['accounts'] }),
  });
}

export function useUpdateAccount() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (updateReq: AccountUpdateRequest) => {
      return await accountService.updateAccount(updateReq);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['accounts'] }),
  });
}

export function useDeleteAccount() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return useMutation({
    mutationFn: async (id: string) => {
      return await accountService.deleteAccount(id, user!.id);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['accounts'] }),
  });
}
